import { ref, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { isPopCertificate } from '@/api/certificate'

export const useCertificateDialog = () => {
  const route = useRoute()
  const store = useStore()

  // 获取证书弹窗状态
  const showCertificate = ref(false)
  const getCertificateStatus = async () => {
    const res = await isPopCertificate(
      {
        questionActiveKey: route.query.questionActiveKey,
        answerGroupKey: route.query.answerGroupKey,
      },
      {
        headers: {
          'CQ-MEMBER-TOKEN': store.getters.getToken,
        },
      }
    )

    if (res.ok) {
      setTimeout(() => {
        showCertificate.value = res.data
      }, 800)
    }
  }

  onMounted(() => {
    // 判断练习还是正式考试
    const resultType = parseInt(route.query.resultType)

    if (resultType === 1) {
      getCertificateStatus()
    }
  })

  // 监听postMessage事件
  window.addEventListener('message', (event) => {
    if (event.data === 'showCertificate') {
      showCertificate.value = true
    }
  })

  return {
    showCertificate,
  }
}
